import offeringService from '@/modules/purchasable/services/offeringService';

const state = {
  packageOfferings: null,
};

const mutations = {
  setPackageOfferings(state, offerings) {
    state.packageOfferings = offerings;
  },
};

const actions = {
  async fetchPackageOfferings({ commit, state }) {
    if (state.packageOfferings) return;

    const offerings = await offeringService.fetchOfferings({ type: 'package', isActive: true });

    if (Array.isArray(offerings)) {
      commit('setPackageOfferings', offerings);
    }
  },
};

const getters = {
  packageOfferings: (state) => state.packageOfferings,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
